import React, { useEffect } from "react";
import {
    Theme,
    makeStyles,
    createStyles,
    Breadcrumbs,
    Typography
} from "@material-ui/core";
import { Link, useLocation, useParams } from "react-router-dom";
import { INavigationItem } from "../../shared/Navigation";
import IProjectHeader from "../../../models/IProjectHeader";
import { apiGet } from "../../../services/api";
import { FOUR_D_VISUALISATION, TRACER_VISION } from "../../../assets/Constants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing(4),
            color: theme.palette.primary.contrastText
        },
        link: {
            color: "inherit",
            "&:visited": {
                color: "inherit"
            },
            cursor: "pointer"
        },
        breadcrumb: {
            color: "inherit",
            "&:visited": {
                color: "inherit"
            },
            textDecoration: "none"
        }
    })
);

export const SimpleBreadcrumbs: React.FC = () => {
    const classes = useStyles();

    const getNavigationItems = (): Array<INavigationItem> | null => {
        const getCurrentPageRegEx = new RegExp("[^/]+$");
        const pathMatch = getCurrentPageRegEx.exec(location.pathname);
        const currentPageName = pathMatch != null ? pathMatch[0] : null;

        const HomeNavigation: INavigationItem = {
            title: "All Projects",
            relativePath: "/projects"
        };
        const DocumentsNavigation: INavigationItem = {
            title: "Documents",
            relativePath: `/projects/${projectId}/documents`
        };
        const SamplesNavigation: INavigationItem = {
            title: "Samples",
            relativePath: `/projects/${projectId}/samples`
        };
        const UsersNavigation: INavigationItem = {
            title: "Users",
            relativePath: `/projects/${projectId}/users`
        };
        const TracerVisionNavigation: INavigationItem = {
            title: TRACER_VISION,
            relativePath: `/projects/${projectId}/TracerVision`
        };
        const VideosNavigation: INavigationItem = {
            title: FOUR_D_VISUALISATION,
            relativePath: `/projects/${projectId}/4d-visualisations`
        };

        const navItems: Array<INavigationItem> = new Array<INavigationItem>(
            HomeNavigation
        );

        switch (currentPageName) {
            case "documents":
                navItems.push(DocumentsNavigation);
                break;
            case "samples":
                navItems.push(SamplesNavigation);
                break;
            case "users":
                navItems.push(UsersNavigation);
                break;
            case "4d-visualisations":
                navItems.push(VideosNavigation);
                break;
            case "TracerVision":
                navItems.push(TracerVisionNavigation);
                break;
        }

        return navItems;
    };

    const { projectId } = useParams();
    const location = useLocation();

    const [navItems, setNavItems] = React.useState<INavigationItem[] | null>(
        getNavigationItems()
    );

    useEffect(() => {
        const getProjectName = async pid => {
            if (pid) {
                const projectHeader = (await apiGet(
                    `projects/${pid}`
                )) as IProjectHeader;

                const items = navItems;

                items?.splice(1, 0, {
                    title: projectHeader.name,
                    relativePath: `/projects/${projectHeader.id}`
                });
                setNavItems(items);
            }
        };
        getProjectName(projectId);
    }, [projectId, navItems, setNavItems]);

    return navItems ? (
        <Breadcrumbs aria-label="breadcrumb" className={classes.root}>
            {navItems.map(function(item, index) {
                if (index === navItems.length - 1) {
                    return (
                        <Typography className={classes.breadcrumb}>
                            {item.title}
                        </Typography>
                    );
                }
                return (
                    <Link
                        key={index}
                        to={item.relativePath}
                        className={classes.link}
                    >
                        {item.title}
                    </Link>
                );
            })}
        </Breadcrumbs>
    ) : (
        <></>
    );
};
